
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Select from 'react-select'
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { useAuthState } from "../../../../../../../../Helper/Context";
import { HeaderIllegal } from "../../../../IllegalConstructionDashboard/HeaderIllegal";
import { ZoneNameCommanDDL } from "../../../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import { Pegination } from "../../../../../../../../Components/Pegination/Pegination";
import { Loading } from "../../../../../../../../Helper/Loading";
import EnchrochmentSidebar from "../../../EnchrochmentSidebar/EnchrochmentSidebar";
import { PinjaraGadiTrackGetTableDataAPI } from "../../../../../../../../Redux/EnchrochmentDashboardSlice/PinjaraGadiTrackSlice/PinjaraGadiTrackSlice";

export const VehicleTrackingGrid = () => {

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const { t } = useTranslation()

    const [searchParams] = useSearchParams()

    // let YearValue = searchParams.get("YearValue")
    // let MonthValue = searchParams.get("MonthValue")
    // let ZoneValue = searchParams.get("ZoneValue");
    let DashSelect = searchParams.get("DashSelect");

    const [IsPost, setIsPost] = useState(false)
    const [loader, setloader] = useState(false)

    const [IsClear, setIsClear] = useState(false)
    const [IsSearch, setIsSearch] = useState(false)

    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)

    const [FromDate, setFromDate] = useState('')
    const [ToDate, setToDate] = useState('')

    // ------------header DDL ------------

    const [YearValue, setYearValue] = useState(sessionStorage.getItem('yearId'))
    const [YearLabel, setYearLabel] = useState(sessionStorage.getItem('yearLable'))
    const [MonthValue, setMonthValue] = useState(sessionStorage.getItem('monthId'))
    const [MonthLabel, setMonthLabel] = useState(sessionStorage.getItem('monthLable'))
    const [ZoneValue, setZoneValue] = useState(sessionStorage.getItem('zoneId'))
    const [ZoneLabel, setZoneLabel] = useState(sessionStorage.getItem('ZoneLable'))

    const [isopen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isopen);
    };

    const [SharePopUpShow, setSharePopUpShow] = useState(false)

    const handleShare = () => {
        setSharePopUpShow(!SharePopUpShow)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })
    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [WardNameID, setWardNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [VehicleID, setVehicleID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const optionsVehicle = [
        { id: 1, value: 'Bike', label: 'Bike' },
        { id: 2, value: 'Car', label: 'Car' },
    ]


    const handleIsPost = () => {
        setIsPost(!IsPost)
        setloader(false)

    }
    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setFromDate('')
        setToDate('')
        setZoneNameID({
            ...ZoneNameID,
            ID: 0,
            Label: 'Select...'
        })
        setWardNameID({
            ...WardNameID,
            ID: 0,
            Label: 'Select...'
        })
    }

    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [ZoneNameID.ID, WardNameID.ID])

    useEffect(() => {
        const data = {
            M_ZoneID: ZoneNameID.ID,
            M_VehicleID: VehicleID.ID,
            Language: Language.Label,
            M_UserID: UserID,
            FromTop: From,
            ToTop: To,
            token: token,
        }
        if (Language.Label != null) {
            dispatch(PinjaraGadiTrackGetTableDataAPI({ data }))
        }
    }, [YearValue, MonthValue, From, IsClear, IsSearch, IsPost, Language.Label, FromDate, ToDate, ZoneValue, WardNameID.ID, ZoneNameID.ID])

    const { isLoading, tableData } = useSelector(state => state.PinjaraGadiTrackGetTableData)

    const [ShowAllMap, setShowAllMap] = useState({
        show: false,
        data: ''
    })
    const [Isloader, setIsloader] = useState(false)

    const handleAllLocation = (item) => {
        setIsloader(true)
        setShowAllMap({
            show: true,
            data: item,
        })
    }
    const handleCloseAllMap = () => {
        setShowAllMap({
            show: false,
            data: ''
        })
    }

    return (
        <>
            {isLoading && <Loading />}

            <HeaderIllegal />
            <div className="wrapper bg-change">
                <EnchrochmentSidebar
                />
                <div className="content1 content mt-1 " style={{}}>

                    <div className="row">
                        <div className="col-12">

                            <h5 className="text-dark fw-bold ps-3 pt-2 all_heading_fontsize">
                                {t('EncroachmentDashboard.VehicleTracking')}


                            </h5>
                        </div>
                    </div>

                    <div className="row ps-3 py-2 eic_table_styles" >
                        <div class="col-12 col-lg-3 pt-2">
                            <ZoneNameCommanDDL
                                ZoneNameID={ZoneNameID}
                                setZoneNameID={setZoneNameID}
                                Flag='Insert'
                                ApiFlag='UserWiseZone'
                                data=''
                                IsPost=''
                                Language={Language}
                            />
                        </div>

                        <div class="col-12 col-lg-3 pt-2">
                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.VehicleName')}</label><br />
                            <Select
                                id='DDLID'
                                isClearable={false}
                                // isRtl={isRtl}
                                isSearchable
                                maxMenuHeight={130}
                                value={{ value: VehicleID.ID, label: VehicleID.Label }}
                                onChange={(e) => {
                                    e ?
                                        setVehicleID({ ...VehicleID, ID: e.value, Label: e.label })
                                        :
                                        setVehicleID({ ...VehicleID, ID: 0, Label: "Select..." })

                                }}
                                options={optionsVehicle}
                            />
                        </div>


                        <div class="col-12 col-lg-3 pt-2">
                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.VehicleNumber')}</label><br />
                            <input type="text" placeholder="" name="date" className="form-control" id="email" required />
                        </div>


                        <div className="col-12 col-lg-3 col-md-4 mt-3">

                            <button type="button" className="btn btn-success mx-3 mt-4">Search</button>
                            <button type="button" className="btn btn-danger mt-4">Clear</button>
                        </div>


                        <div className="row" >
                            <div className="col-12  " >
                                <div className="table-responsive pt-3">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.date')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ZoneName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.VehicleStartPlace')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Shift')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.VehicleName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.VehicleModule')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.VehicleNumber')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Track')}</th>

                                            </tr>

                                        </thead>
                                        <tbody>
                                            {
                                                tableData && tableData?.length > 0 ? tableData?.map((i, j) => {
                                                    return (
                                                        <tr>
                                                            <td className="py-1" align="center">{i.rowNum}</td>
                                                            <td >{i.trackingDate ? moment(i.trackingDate).format("DD-MM-YYYY") : '-'}</td>
                                                            <td >{i.zoneName ? i.zoneName : '-'}</td>
                                                            <td >{i.place ? i.place : '-'}</td>
                                                            <td >-</td>
                                                            <td >{i.vehicleName ? i.vehicleName : '-'}</td>
                                                            <td >{i.vehicleModel ? i.vehicleModel : '-'}</td>
                                                            <td >{i.vehicleNumber ? i.vehicleNumber : '-'}</td>

                                                            <td className="text-center">
                                                                <button className="Track_button"
                                                                    onClick={() => handleAllLocation(i)}
                                                                >
                                                                    {/* {t('EncroachmentDashboard.Track')} */}
                                                                    <i class="fa-solid fa-location-dot"></i>
                                                                </button>
                                                            </td>

                                                        </tr>
                                                    )
                                                })
                                                    :
                                                    <tr>
                                                        <td colSpan={10}>No data found ...</td>
                                                    </tr>
                                            }

                                        </tbody>
                                    </table>
                                </div>
                                {tableData && tableData.length > 0 &&
                                    <Pegination
                                        PerPageCount={PerPageCount}
                                        TotalCount={tableData && tableData[0].totalCount}
                                        setFrom={setFrom}
                                        setTo={setTo}
                                        CurrentPage={CurrentPage}
                                        setCurrentPage={setCurrentPage}
                                        IsClear={IsClear}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* {
                ShowAllMap.show &&
                <SingleTableMapView
                    ShowAllMap={ShowAllMap}
                    handleCloseAllMap={handleCloseAllMap}
                    YearSelected={YearValue}
                    setIsloader={setIsloader}
                />
            } */}
        </>
    )
}

